import AssistantMessageStyles from './AssistantMessage.module.scss';

/**
 * Custom markdown components for ReactMarkdown
 * Provides custom rendering for code blocks, links, tables, and blockquotes
 * 
 * @param {function} onAction - Callback for actions (copy, etc.)
 * @returns {Object} Component overrides for ReactMarkdown
 */
export const createMarkdownComponents = (onAction) => ({
  // Code blocks with syntax highlighting placeholder
  code({ node, inline, className: codeClassName, children, ...props }) {
    const match = /language-(\w+)/.exec(codeClassName || '');
    const language = match ? match[1] : '';

    if (inline) {
      return (
        <code className={AssistantMessageStyles['inline-code']} {...props}>
          {children}
        </code>
      );
    }

    return (
      <div className={AssistantMessageStyles['code-block-wrapper']}>
        {language && (
          <div className={AssistantMessageStyles['code-language']}>
            {language}
          </div>
        )}
        <pre className={AssistantMessageStyles['code-block']}>
          <code className={codeClassName} {...props}>
            {children}
          </code>
        </pre>
        <button
          className={AssistantMessageStyles['copy-button']}
          onClick={() => {
            const text = String(children).replace(/\n$/, '');
            navigator.clipboard.writeText(text);
            onAction?.('copy', { content: text, type: 'code' });
          }}
          type="button"
          aria-label="Copy code"
        >
          Copy
        </button>
      </div>
    );
  },
  // Links open in new tab
  a({ node, children, href, ...props }) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={AssistantMessageStyles['link']}
        {...props}
      >
        {children}
      </a>
    );
  },
  // Tables with styling
  table({ node, children, ...props }) {
    return (
      <div className={AssistantMessageStyles['table-wrapper']}>
        <table className={AssistantMessageStyles['table']} {...props}>
          {children}
        </table>
      </div>
    );
  },
  // Blockquotes
  blockquote({ node, children, ...props }) {
    return (
      <blockquote className={AssistantMessageStyles['blockquote']} {...props}>
        {children}
      </blockquote>
    );
  }
});